<template>
    <v-dialog v-model="showDialog" max-width="1900px" persistent scrollable>
        <v-card class="addDevice-modal">
            <v-card-title class="bg-gray-light">
                <span class="text-h5" style="font-size: 1.2rem !important;">{{ $t(nameLabel) }}</span>
                <v-btn class="ml-auto" icon @click.prevent="handleConfirmCloseModal">
                    <v-icon id="close-button">mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text style="height: 600px;">
                <v-container style="max-width:1835px !important;" class="pt-0 pb-0">
                    <div class="row mt-10">
                        <div class="col-12">
                            <table class="table" style="width: 100%; border: 1px solid #ebebeb;">
                                <thead style="text-transform: uppercase;">
                                    <tr>
                                        <th>{{ $t("labels.deviceMaster.ngFlg.item") }}</th>
                                        <th>{{ $t("labels.deviceMaster.ngFlg.dataMapping") }}</th>
                                        <th>{{ $t("labels.deviceMaster.ngFlg.checkFlg") }}</th>
                                        <th>{{ $t("labels.deviceMaster.ngFlg.logic") }}</th>
                                        <th>{{ $t("labels.deviceMaster.ngFlg.result") }}</th>
                                        <th>{{ $t("labels.deviceMaster.ngFlg.value") }}</th>
                                    </tr>
                                </thead>
                                <tbody v-if="type == 1">
                                    <tr>
                                        <td rowspan="2">{{ $i18n.locale === 'en' ? 'Gauge' : '軌間' }}</td> 
                                        <td rowspan="2">d1</td> 
                                        <td rowspan="2">16</td> 
                                        <td>(NG_Flg Or CheckFlg) = NG_Flg</td> 
                                        <td>TRUE</td> 
                                        <td>NG</td>
                                    </tr>
                                    <tr>
                                        <td>(NG_Flg Or CheckFlg) = NG_Flg</td> 
                                        <td>FALSE</td> 
                                        <td>{{ $i18n.locale === 'en' ? 'Numerical display' : '数値表示' }}</td>
                                    </tr>
                                    <tr>
                                        <td rowspan="2">{{ $i18n.locale === 'en' ? 'Cross level' : '水準' }}</td> 
                                        <td rowspan="2">d2</td> 
                                        <td rowspan="2">16</td> 
                                        <td>(NG_Flg Or CheckFlg) = NG_Flg</td> 
                                        <td>TRUE</td> 
                                        <td>NG</td>
                                    </tr>
                                    <tr>
                                        <td>(NG_Flg Or CheckFlg) = NG_Flg</td> 
                                        <td>FALSE</td> 
                                        <td>{{ $i18n.locale === 'en' ? 'Numerical display' : '数値表示' }}</td>
                                    </tr>
                                    <tr>
                                        <td rowspan="3">{{ $i18n.locale === 'en' ? 'Longitudinal level/surface(Standard)' : '高低（基準)' }}</td> 
                                        <td rowspan="3">d3</td> 
                                        <td>4</td> 
                                        <td>(NG_Flg Or CheckFlg) = NG_Flg</td> 
                                        <td>TRUE</td> 
                                        <td>NG</td>
                                    </tr>
                                    <tr>
                                        <td>1</td> 
                                        <td>(NG_Flg Or CheckFlg) = NG_Flg</td> 
                                        <td>TRUE</td> 
                                        <td>***</td>
                                    </tr>
                                    <tr>
                                        <td></td> 
                                        <td>{{ $i18n.locale === 'en' ? 'Both of the above are false' : '上記２つともFALSE' }}</td> 
                                        <td></td> 
                                        <td>{{ $i18n.locale === 'en' ? 'Numerical display' : '数値表示' }}</td>
                                    </tr>
                                    <tr>
                                        <td rowspan="3">{{ $i18n.locale === 'en' ? 'Longitudinal level/surface(Opposite)' : '高低（反対)' }}</td> 
                                        <td rowspan="3">d4</td> 
                                        <td>8</td> 
                                        <td>(NG_Flg Or CheckFlg) = NG_Flg</td> 
                                        <td>TRUE</td> 
                                        <td>NG</td>
                                    </tr>
                                    <tr>
                                        <td>1</td> 
                                        <td>(NG_Flg Or CheckFlg) = NG_Flg</td> 
                                        <td>TRUE</td> 
                                        <td>***</td>
                                    </tr>
                                    <tr>
                                        <td></td> 
                                        <td>{{ $i18n.locale === 'en' ? 'Both of the above are false' : '上記２つともFALSE' }}</td> 
                                        <td></td> 
                                        <td>{{ $i18n.locale === 'en' ? 'Numerical display' : '数値表示' }}</td>
                                    </tr>
                                    <tr>
                                        <td rowspan="3">{{ $i18n.locale === 'en' ? 'Alignment(Standard)' : '通り（基準)' }}</td> 
                                        <td rowspan="3">d5</td> 
                                        <td>4</td> 
                                        <td>(NG_Flg Or CheckFlg) = NG_Flg</td> 
                                        <td>TRUE</td> 
                                        <td>NG</td>
                                    </tr>
                                    <tr>
                                        <td>1</td> 
                                        <td>(NG_Flg Or CheckFlg) = NG_Flg</td> 
                                        <td>TRUE</td> 
                                        <td>***</td>
                                    </tr>
                                    <tr>
                                        <td></td> 
                                        <td>{{ $i18n.locale === 'en' ? 'Both of the above are false' : '上記２つともFALSE' }}</td> 
                                        <td></td> 
                                        <td>{{ $i18n.locale === 'en' ? 'Numerical display' : '数値表示' }}</td>
                                    </tr>
                                    <tr>
                                        <td rowspan="3">{{ $i18n.locale === 'en' ? 'Alignment(Opposite)' : '通り（反対)' }}</td> 
                                        <td rowspan="3">d6</td> 
                                        <td>8</td> 
                                        <td>(NG_Flg Or CheckFlg) = NG_Flg</td> 
                                        <td>TRUE</td> 
                                        <td>NG</td>
                                    </tr>
                                    <tr>
                                        <td>1</td> 
                                        <td>(NG_Flg Or CheckFlg) = NG_Flg</td> 
                                        <td>TRUE</td> 
                                        <td>***</td>
                                    </tr>
                                    <tr>
                                        <td></td> 
                                        <td>{{ $i18n.locale === 'en' ? 'Both of the above are false' : '上記２つともFALSE' }}</td> 
                                        <td></td> 
                                        <td>{{ $i18n.locale === 'en' ? 'Numerical display' : '数値表示' }}</td>
                                    </tr>
                                    <tr>
                                        <td rowspan="5">{{ $i18n.locale === 'en' ? 'Twist/cross level change' : '平面性' }}</td> 
                                        <td rowspan="5">d7</td> 
                                        <td>2</td> 
                                        <td>(NG_Flg Or CheckFlg) = NG_Flg</td> 
                                        <td>TRUE</td> 
                                        <td>NG</td>
                                    </tr>
                                    <tr>
                                        <td>1</td> 
                                        <td>(NG_Flg Or CheckFlg) = NG_Flg</td> 
                                        <td>TRUE</td> 
                                        <td rowspan="3">***</td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td>And</td> 
                                        <td></td> 
                                    </tr>
                                    <tr>
                                        <td>32</td> 
                                        <td>(NG_Flg Or CheckFlg) = NG_Flg</td> 
                                        <td>FALSE</td> 
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td>{{ $i18n.locale === 'en' ? 'Other than above' : '上記以外' }}</td> 
                                        <td></td> 
                                        <td>{{ $i18n.locale === 'en' ? 'Numerical display' : '数値表示' }}</td>
                                    </tr>
                                </tbody>
                                <tbody v-if="type == 2">
                                    <tr>
                                        <td rowspan="3">{{ $i18n.locale === 'en' ? 'Gauge' : '軌間' }}</td> 
                                        <td rowspan="3">d1</td> 
                                        <td>256</td> 
                                        <td>(NG_Flg And CheckFlg) = CheckFlg</td> 
                                        <td>TRUE</td> 
                                        <td>**</td>
                                    </tr>
                                    <tr>
                                        <td>1</td> 
                                        <td>(NG_Flg And CheckFlg) = CheckFlg</td> 
                                        <td>TRUE</td> 
                                        <td>NG</td>
                                    </tr>
                                    <tr>
                                        <td></td> 
                                        <td>{{ $i18n.locale === 'en' ? 'Both of the above are false' : '上記２つともFALSE' }}</td> 
                                        <td></td> 
                                        <td>{{ $i18n.locale === 'en' ? 'Numerical display' : '数値表示' }}</td>
                                    </tr>
                                    <tr>
                                        <td rowspan="3">{{ $i18n.locale === 'en' ? 'Cross level' : '水準' }}</td> 
                                        <td rowspan="3">d2</td> 
                                        <td>512</td> 
                                        <td>(NG_Flg And CheckFlg) = CheckFlg</td> 
                                        <td>TRUE</td> 
                                        <td>**</td>
                                    </tr>
                                    <tr>
                                        <td>2</td> 
                                        <td>(NG_Flg And CheckFlg) = CheckFlg</td> 
                                        <td>TRUE</td> 
                                        <td>NG</td>
                                    </tr>
                                    <tr>
                                        <td></td> 
                                        <td>{{ $i18n.locale === 'en' ? 'Both of the above are false' : '上記２つともFALSE' }}</td> 
                                        <td></td> 
                                        <td>{{ $i18n.locale === 'en' ? 'Numerical display' : '数値表示' }}</td>
                                    </tr>
                                    <tr>
                                        <td rowspan="3">{{ $i18n.locale === 'en' ? 'Longitudinal level/surface(Standard)' : '高低（基準)' }}</td> 
                                        <td rowspan="3">d3</td> 
                                        <td>1024</td> 
                                        <td>(NG_Flg And CheckFlg) = CheckFlg</td> 
                                        <td>TRUE</td> 
                                        <td>**</td>
                                    </tr>
                                    <tr>
                                        <td>4</td> 
                                        <td>(NG_Flg And CheckFlg) = CheckFlg</td> 
                                        <td>TRUE</td> 
                                        <td>NG</td>
                                    </tr>
                                    <tr>
                                        <td></td> 
                                        <td>{{ $i18n.locale === 'en' ? 'Both of the above are false' : '上記２つともFALSE' }}</td> 
                                        <td></td> 
                                        <td>{{ $i18n.locale === 'en' ? 'Numerical display' : '数値表示' }}</td>
                                    </tr>
                                    <tr>
                                        <td rowspan="3">{{ $i18n.locale === 'en' ? 'Longitudinal level/surface(Opposite)' : '高低（反対)' }}</td> 
                                        <td rowspan="3">d4</td> 
                                        <td>2048</td> 
                                        <td>(NG_Flg And CheckFlg) = CheckFlg</td> 
                                        <td>TRUE</td> 
                                        <td>**</td>
                                    </tr>
                                    <tr>
                                        <td>4</td> 
                                        <td>(NG_Flg And CheckFlg) = CheckFlg</td> 
                                        <td>TRUE</td> 
                                        <td>NG</td>
                                    </tr>
                                    <tr>
                                        <td></td> 
                                        <td>{{ $i18n.locale === 'en' ? 'Both of the above are false' : '上記２つともFALSE' }}</td> 
                                        <td></td> 
                                        <td>{{ $i18n.locale === 'en' ? 'Numerical display' : '数値表示' }}</td>
                                    </tr>
                                    <tr>
                                        <td rowspan="3">{{ $i18n.locale === 'en' ? 'Alignment(Standard)' : '通り（基準)' }}</td> 
                                        <td rowspan="3">d5</td> 
                                        <td>4096</td> 
                                        <td>(NG_Flg And CheckFlg) = CheckFlg</td> 
                                        <td>TRUE</td> 
                                        <td>**</td>
                                    </tr>
                                    <tr>
                                        <td>16</td> 
                                        <td>(NG_Flg And CheckFlg) = CheckFlg</td> 
                                        <td>TRUE</td> 
                                        <td>NG</td>
                                    </tr>
                                    <tr>
                                        <td></td> 
                                        <td>{{ $i18n.locale === 'en' ? 'Both of the above are false' : '上記２つともFALSE' }}</td> 
                                        <td></td> 
                                        <td>{{ $i18n.locale === 'en' ? 'Numerical display' : '数値表示' }}</td>
                                    </tr>
                                    <tr>
                                        <td rowspan="3">{{ $i18n.locale === 'en' ? 'Alignment(Opposite)' : '通り（反対)' }}</td> 
                                        <td rowspan="3">d6</td> 
                                        <td>8192</td> 
                                        <td>(NG_Flg And CheckFlg) = CheckFlg</td> 
                                        <td>TRUE</td> 
                                        <td>**</td>
                                    </tr>
                                    <tr>
                                        <td>32</td> 
                                        <td>(NG_Flg And CheckFlg) = CheckFlg</td> 
                                        <td>TRUE</td> 
                                        <td>NG</td>
                                    </tr>
                                    <tr>
                                        <td></td> 
                                        <td>{{ $i18n.locale === 'en' ? 'Both of the above are false' : '上記２つともFALSE' }}</td> 
                                        <td></td> 
                                        <td>{{ $i18n.locale === 'en' ? 'Numerical display' : '数値表示' }}</td>
                                    </tr>
                                    <tr>
                                        <td rowspan="3">{{ $i18n.locale === 'en' ? 'Twist/cross level change' : '平面性' }}</td> 
                                        <td rowspan="3">d7</td> 
                                        <td>16384</td> 
                                        <td>(NG_Flg And CheckFlg) = CheckFlg</td> 
                                        <td>TRUE</td> 
                                        <td>**</td>
                                    </tr>
                                    <tr>
                                        <td>64</td> 
                                        <td>(NG_Flg And CheckFlg) = CheckFlg</td> 
                                        <td>TRUE</td> 
                                        <td>NG</td>
                                    </tr>
                                    <tr>
                                        <td></td> 
                                        <td>{{ $i18n.locale === 'en' ? 'Both of the above are false' : '上記２つともFALSE' }}</td> 
                                        <td></td> 
                                        <td>{{ $i18n.locale === 'en' ? 'Numerical display' : '数値表示' }}</td>
                                    </tr>
                                    <tr>
                                        <td rowspan="3">{{ $i18n.locale === 'en' ? 'd8' : 'd8' }}</td> 
                                        <td rowspan="3">d8</td> 
                                        <td>32768</td> 
                                        <td>(NG_Flg And CheckFlg) = CheckFlg</td> 
                                        <td>TRUE</td> 
                                        <td>**</td>
                                    </tr>
                                    <tr>
                                        <td>128</td> 
                                        <td>(NG_Flg And CheckFlg) = CheckFlg</td> 
                                        <td>TRUE</td> 
                                        <td>NG</td>
                                    </tr>
                                    <tr>
                                        <td></td> 
                                        <td>{{ $i18n.locale === 'en' ? 'Both of the above are false' : '上記２つともFALSE' }}</td> 
                                        <td></td> 
                                        <td>{{ $i18n.locale === 'en' ? 'Numerical display' : '数値表示' }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="bg-secondary text-white" text @click.prevent="handleConfirmCloseModal">
                    {{ $t("labels.deviceMaster.close") }}
                </v-btn>
            </v-card-actions>
        </v-card>
        <v-overlay :value="loading">
            <v-progress-circular indeterminate size="64" style="color: #3d76ad !important;"></v-progress-circular>
        </v-overlay>
    </v-dialog>
</template>

<script>
import { EventBus } from '@/utils/eventBus.js';
import $ from 'jquery';
import {} from "@/utils/validate";
export default {
    name: "PopupNGFLGModal",
    props: ['visible'],
    data() {
        return {
            loading: false,
            showDialog: false,
            nameLabel: "",
            type: 1,
        }
    },
    created() {
        EventBus.$on('handleOpenPopupNGFLGModal', (value) => {
            if (value.Flg) {
                $('#main-header').css("pointer-events", "none");
            } else {
                $('#main-header').css("pointer-events", "");
            }
            this.showDialog = value.Flg;
            this.nameLabel = value.nameLabel;
            this.type = value.type
        });
    },
    methods: {
        handleConfirmCloseModal() {
            this.showDialog = false;
            $('#main-header').css("pointer-events", "");
        },
    },
    watch: {
    '$i18n.locale': async function (currentLang) {
    await import(`@/utils/errors/deviceMaster/${currentLang}.js`)
        .then((DATA) => {
          this.ERROR_CODE = DATA.ERROR_CODE
        })
        .catch(async () => {
          await import(`@/utils/errors/deviceMaster/${currentLang}.js`)
            .then((DATA) => {
              this.ERROR_CODE = DATA.ERROR_CODE
            })
        })
    },
  },
}
</script>

<style lang="scss" scoped>
table tbody tr td{
    color: black;
    align-content: center;
    text-align: center;
}
</style>